<template>
  <v-card class="chart-card d-flex flex-column" outlined>
    <v-card-title class="d-flex justify-space-between align-center pb-2">
      <div class="d-flex align-center">
        <v-icon v-if="icon" :color="icon_color" class="mr-2">{{ icon }}</v-icon>
        <span>{{ title }}</span>
      </div>
      <slot name="title-actions" />
    </v-card-title>

    <v-card-subtitle v-if="subtitle" class="pt-0 pb-2">
      {{ subtitle }}
    </v-card-subtitle>

    <v-card-text class="flex-grow-1 d-flex flex-column">
      <slot v-if="loading">
        <div class="d-flex align-center justify-center flex-grow-1">
          <v-progress-circular indeterminate color="primary" />
        </div>
      </slot>

      <slot v-else-if="has_data" />

      <div v-else class="d-flex align-center justify-center no-data-message flex-grow-1">
        <div class="text-center">
          <v-icon size="64" color="grey lighten-1">{{ no_data_icon }}</v-icon>
          <p class="text-h6 grey--text text--lighten-1 mt-4 mb-0">{{ no_data_text }}</p>
          <p v-if="no_data_subtext" class="text-body-2 grey--text text--lighten-2 mt-2 mb-0">
            {{ no_data_subtext }}
          </p>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
/**
 * Card component for displaying charts with a title, subtitle, and loading/no-data states.
 */

export default {
  name: 'ChartCard',

  props: {
    title: {
      type: String,
      required: true,
    },

    subtitle: {
      type: String,
      default: '',
    },

    icon: {
      type: String,
      default: '',
    },

    icon_color: {
      type: String,
      default: 'primary',
    },

    has_data: {
      type: Boolean,
      default: true,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    no_data_icon: {
      type: String,
      default: 'mdi-chart-line',
    },

    no_data_text: {
      type: String,
      default: 'No data available',
    },

    no_data_subtext: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-card {
  height: 100%;
  min-height: 450px;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  }

  .no-data-message {
    height: 100%;
    min-height: 250px;
  }
}
</style>
